import { Box, Link, Paper, Stack } from "@mui/material";
import { useSSTheme } from "../hooks/useSSTheme";
import { SSText } from "src/components/base/components/SSText";
import { useLogout } from "../hooks/useLogout";

interface Props {
  email?: string;
  accountId?: any;
}

export function TmAccountDetails(props: Props) {
  const theme = useSSTheme();
  const { handleLogout } = useLogout();

  if (props.email) {
    return (
      <Paper
        variant="outlined"
        sx={{
          padding: 2,
          backgroundColor: theme.colors.gray["50"],
          borderRadius: "8px",
        }}
      >
        <Stack>
          <SSText variant="body" fontWeight={700} fontSize={`1rem`}>
            {props?.email}
          </SSText>
          {props?.accountId ? (
            <SSText variant="body" color="text.secondary" fontWeight={"600"}>
              Account #{props?.accountId}
            </SSText>
          ) : null}
          <Box mt={1}>
            <SSText variant="body">
              Wrong Account?{" "}
              <Link
                onClick={() => handleLogout()}
                sx={{
                  cursor: "pointer",
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
              >
                Click here
              </Link>{" "}
              to change account
            </SSText>
          </Box>
        </Stack>
      </Paper>
    );
  }

  return null;
}
